/* eslint-disable global-require */
import React from "react";
import { useTranslation } from "react-i18next";

import Reviews from "./Reviews";

import {
  Panel,
  ReviewContainer,
  ReviewTitleText,
  AccreditedContainer,
  CountryName,
  Link,
  ContactText,
  SchoolContainer,
  ContactEmail,
  SocialImage,
} from "./ContactStyle";

const ReviewPanel = () => {
  const { t } = useTranslation("registration");

  return (
    <Panel>
      <ReviewContainer>
        <Reviews />
      </ReviewContainer>
      <ReviewContainer>
        <ReviewTitleText>
          {t("The Internet's Favorite Language School")}
        </ReviewTitleText>
        <SchoolContainer>
          <div>
            <a
              href="https://www.facebook.com/LTLSchool/reviews/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialImage
                src={require("assets/reviews/block-facebook.jpg")}
                alt="facebook"
              />
            </a>
          </div>
          <div>
            <a
              href="https://g.page/ltl-online-school?share"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialImage
                src={require("assets/reviews/block-google.jpg")}
                alt="google"
              />
            </a>
          </div>
          <div>
            <a
              href="https://www.trustpilot.com/review/ltl-school.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SocialImage
                src={require("assets/reviews/block-trustpilot.jpg")}
                alt="trustpilot"
              />
            </a>
          </div>
        </SchoolContainer>
      </ReviewContainer>
      <ReviewContainer>
        <ReviewTitleText>{t("We Are Accredited By")}</ReviewTitleText>
        <AccreditedContainer size="small">
          <img src={require("assets/reviews/flag-de.png")} alt="Germany flag" />
          <CountryName>{t("Germany")}</CountryName>
          <Link target="_blank" href="Bildungsurlaub Anerkennung LTL.jpeg">
            {t("Bildungsurlaub Accredited")}
          </Link>
        </AccreditedContainer>
        <AccreditedContainer>
          <img src={require("assets/reviews/flag-se.png")} alt="Sweden flag" />
          <CountryName>{t("Sweden")}</CountryName>
          <Link
            target="_blank"
            href="https://www.csn.se/languages/english.html"
          >
            {t("CSN Accredited")}
          </Link>
        </AccreditedContainer>
        <AccreditedContainer>
          <img
            src={require("assets/reviews/flag-au.png")}
            alt="Australia flag"
          />
          <CountryName>{t("Australia")}</CountryName>
          <Link
            target="_blank"
            href="https://www.dfat.gov.au/people-to-people/new-colombo-plan/about"
          >
            {t("Colombo Plan Accredited")}
          </Link>
        </AccreditedContainer>
      </ReviewContainer>
      <ReviewContainer>
        <ReviewTitleText>{t("Questions?")}</ReviewTitleText>
        <ContactText>{t("Contact us at 24/7 on")}</ContactText>
        <ContactEmail href="mailto:support@flexiclasses.com">
          {t("support@flexiclasses.com")}
        </ContactEmail>
      </ReviewContainer>
    </Panel>
  );
};

export default ReviewPanel;
